import React from 'react';
import { isFormValid, validated } from 'react-custom-validation';
import PropTypes from 'prop-types';
import update from "immutability-helper";

import { isEmail, isRequired } from '../../util/validations';
import { handleTextChange } from '../../util/handle-changes';

import { Routes } from '../../_controllers/RouteController';

import ActivityIndicator from '../../_components/FormComponents/ActivityIndicator';
import Button from '../../_components/FormComponents/Button';
import Form from '../../_components/FormComponents/Form';
import FormValidationMessage from '../../_components/FormComponents/FormValidationMessage';
import FormRow from '../../_components/FormComponents/FormRow';

import Textbox from '../../_components/FormComponents/Textbox';
import {AcceptTos} from "./AcceptTos";
import {Link} from "react-router-dom";

class SignupForm extends React.Component {
    static propTypes = {
        account: PropTypes.object.isRequired,
        error: PropTypes.object,
        isSubmitting: PropTypes.bool.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        setAccount: PropTypes.func.isRequired,
    };

    handleChange = (name, value) => {
        let newAccountObj = update(this.props.account, {});
        newAccountObj[name] = value;
        this.props.setAccount(newAccountObj);
    };

    render() {
        let { account, error, isSubmitting, handleSubmit, $field, $validation } = this.props;

        return (
            <Form className="login-form auth-page__form">


                <FormRow>
                    <Textbox
                        id="txtFirstName"
                        label="First Name"
                        labelHidden
                        name="firstName"
                        placeholder="First Name (Required)"
                        required
                        type="text"
                        validation={$validation.firstName}
                        value={account.firstName || ''}
                        {...$field('firstName', (event) => handleTextChange(this.handleChange, event))}
                    />
                </FormRow>
                <FormRow>
                    <Textbox
                        id="txtLastName"
                        label="Last Name"
                        labelHidden
                        name="lastName"
                        placeholder="Last Name (Required)"
                        required
                        type="text"
                        validation={$validation.lastName}
                        value={account.lastName || ''}
                        {...$field('lastName', (event) => handleTextChange(this.handleChange, event))}
                    />
                </FormRow>
                <FormRow>
                    <Textbox
                        id="txtEmailAddress"
                        label="Email"
                        labelHidden
                        name="email"
                        placeholder="Email (Required)"
                        required
                        type="email"
                        validation={$validation.email}
                        value={account.email || ''}
                        {...$field('email', (event) => handleTextChange(this.handleChange, event))}
                    />
                </FormRow>

                <FormRow>
                    <Textbox
                        id="txtPassword"
                        label="Password"
                        labelHidden
                        name="password"
                        placeholder="Password (Required)"
                        required
                        type="password"
                        validation={$validation.password}
                        value={account.password || ''}
                        {...$field('password', (event) => handleTextChange(this.handleChange, event))}
                    />
                </FormRow>

                {error && Object.keys(error).length > 0 ? (
                    <FormRow className="error-message">
                        <FormValidationMessage>
                            {error.friendlyMessage || error.message}
                        </FormValidationMessage>
                    </FormRow>
                ) : null}

                <div className="auth-page__form__footer">
                    <AcceptTos />
                    <p className="auth-page__help-text">
                        Already have an account? <Link to="/login">Login</Link>
                    </p>
                    <FormRow className="c-form__button-wrapper">
                        <Button className='c-button--block'
                                disabled={isFormValid($validation) !== true || isSubmitting === true}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.props.$submit(() => handleSubmit(true), () => handleSubmit(false));
                                }}
                                type="submit">
                            Create a New Account
                            {isSubmitting === true ? <ActivityIndicator color="#ffffff" /> : null}
                        </Button>
                    </FormRow>
                </div>
            </Form>
        )
    }
}

function loginFormValidationConfig(props) {
    const { firstName, lastName, email, password } = props.account;

    return {
        fields: ['firstName', 'lastName', 'email', 'password'],
        validations: {
            firstName: [
                [isRequired, firstName]
            ],
            lastName: [
                [isRequired, lastName]
            ],
            email: [
                [isRequired, email],
                [isEmail, email]
            ],
            password: [
                [isRequired, password]
            ]
        }
    }
}

export default SignupForm = validated(loginFormValidationConfig)(SignupForm);



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/SignupForm.js